import { login, logout, me } from "@/lib/api/auth";
import { LoginPayload, SessionState } from "@/types/auth";

export function isDashboardRole(role?: string | null): role is "merchant" | "enabler" {
  return role === "merchant" || role === "enabler";
}

export async function performLogin(payload: LoginPayload): Promise<SessionState> {
  const response = await login(payload);
  console.log("Login Response:", JSON.stringify(response, null, 2));

  if (response.success && response.data && isDashboardRole(response.data.role)) {
    return {
      status: "authenticated",
      isAuthenticated: true,
      user: response.data
    };
  }

  if (response.success && response.data && !isDashboardRole(response.data.role)) {
    await logout();
    return {
      status: "unauthenticated",
      isAuthenticated: false,
      errorMessage: "Unauthorized role"
    };
  }

  return {
    status: "error",
    isAuthenticated: false,
    errorMessage: response.message
  };
}

export async function bootstrapSession(): Promise<SessionState> {
  const response = await me();

  if (response.success && response.data && isDashboardRole(response.data.role)) {
    return {
      status: "authenticated",
      isAuthenticated: true,
      user: response.data
    };
  }

  if (response.success && response.data && !isDashboardRole(response.data.role)) {
    await logout();
    return {
      status: "unauthenticated",
      isAuthenticated: false,
      errorMessage: "Unauthorized role"
    };
  }

  return {
    status: "unauthenticated",
    isAuthenticated: false,
    errorMessage: response.message
  };
}

export async function performLogout(): Promise<SessionState> {
  await logout();

  return {
    status: "unauthenticated",
    isAuthenticated: false
  };
}
